import { useEffect, useState } from 'react';

import { servGetIndicadoresPorEstabelecimentoAndPeriodo } from '../../../servicos/graficos_indicador';
import { formataDate } from '../../../util/datas';
import { formataOperadoresRelacionaisMetrica } from '../../../util/utilitarios'

function TabelaDetalhamentoIndicadorEstabelecimento({ dataInicio, dataFim, estabelecimento }) {

    console.log('### Iniciando TabelaDetalhamentoIndicadorEstabelecimento ###');

    const [dadosIndicadores, setDadosIndicadores] = useState(null)

    useEffect(() => {
        getIndicadoresPorEstabelecimentoAndPeriodo()
    }, [estabelecimento, dataInicio, dataFim]);

    const getIndicadoresPorEstabelecimentoAndPeriodo = async () => {
        try {

            const dadosIndicadoresDaApi = await servGetIndicadoresPorEstabelecimentoAndPeriodo(dataInicio, dataFim, estabelecimento.id)

            const agrupados = dadosIndicadoresDaApi.data.reduce((acc, item) => {
                const mes = item.mesReferencia;
                if (!acc[mes]) {
                    acc[mes] = [];
                }
                acc[mes].push(item);
                return acc;
            }, {});

            setDadosIndicadores(agrupados)

        } catch (erro) {
            console.error(erro);
        }
    }

    return (
        <div className='d-flex flex-wrap'>
            {dadosIndicadores && Object.entries(dadosIndicadores).map(([mes, metricas]) => (
                <div className='p-1 col-4' key={mes}>
                    <table className='table' border="1">
                        <thead>
                            <tr className=''>
                                <th
                                    style={{ 'backgroundColor': '#f5f3f3' }}
                                    className='text-center'
                                    colSpan="5"
                                >
                                    {formataDate(mes, 'MMMM yyyy').toUpperCase()}
                                </th>
                            </tr>
                            <tr>
                                <th>Indicador</th>
                                <th>Meta</th>
                                <th>Resultado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {metricas.map((indicador) => (
                                <tr
                                    className={
                                        indicador.nsa
                                            ? 'default'
                                            :
                                            indicador.metaAlcancada
                                                ? 'table-success'
                                                : 'table-danger'
                                    }
                                    key={indicador.id}
                                >
                                    <td>{indicador.metricaCodigo}</td>
                                    <td>{formataOperadoresRelacionaisMetrica(indicador.meta)}</td>
                                    <td>{indicador.nsa ? 'NSA' : indicador.resultado}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div >
    )
}

export default TabelaDetalhamentoIndicadorEstabelecimento
